<div class="configuration-status" data-cy="configuration-status-div">
  <div class="status {{ status }}" *ngIf="status">
    <p>Status</p>
    <p class="status-value"> {{ getStatus.label }}</p>
  </div>
</div>
